import { render, staticRenderFns } from "./PointsStore.vue?vue&type=template&id=8826db4a&"
import script from "./PointsStore.vue?vue&type=script&lang=js&"
export * from "./PointsStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports